var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarburst = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25 9.267 0l.819 1.581 1.591-.798.29 1.756 1.76-.267-.267 1.76 1.756.29-.797 1.591L16 6.732l-1.25 1.267L16 9.266l-1.581.819.797 1.591-1.756.29.267 1.76-1.76-.267-.29 1.756-1.591-.798-.819 1.581L8 14.748l-1.267 1.25-.819-1.581-1.591.798-.29-1.756-1.76.267.267-1.76-1.756-.29.797-1.591L0 9.266l1.25-1.267L0 6.732l1.581-.819-.797-1.591 1.756-.29-.267-1.76 1.76.267.29-1.756 1.591.798L6.733 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarburst);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/starburst.svg";